import React from 'react';
import PropTypes from 'prop-types';

import classNames from '../../utils/classNames';

import styles from './panel.scss';

export default function Panel(props) {
    const {
        animated,
        fill,
        fixed,
        separated,
        contentStyles,
        header,
        noShrink,
        children,
    } = props;

    const wrapperClasses = classNames(styles.wrapper, {
        [styles.fill]: fill,
        [styles.fixed]: fixed,
        [styles.separated]: separated,
        [styles.animated]: animated,
        [styles.noShrink]: noShrink,
    });

    return (
        <div className={wrapperClasses} style={props.style}>
            {header !== undefined && header}
            <div className={styles.content + ' panel-in'} style={contentStyles}>
                {children}
                <div className="popouts-portal"></div>
            </div>
        </div>
    );
};

Panel.propTypes = {
    children: PropTypes.any,
    animated: PropTypes.bool,
    /**
     * Panel reserves all available horizontal space.
     */
    fill: PropTypes.bool,
    /**
     * Should panel shrink when reach minWidth?
     */
    noShrink: PropTypes.bool,
    /**
     * Panel reserves all available vertical space.
     */
    fixed: PropTypes.bool,
    /**
     * Display gray separator on the left side of the panel.
     */
    separated: PropTypes.bool,
    /**
     * Styles to apply to the panel content DIV.
     */
    contentStyles: PropTypes.object,
    /**
     * Styles to apply to the panel DIV.
     */
    style: PropTypes.object,
    /**
     * Panel Header component
     */
    header: PropTypes.element,
};
